import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { IReview, ITask } from '../models/review';

@Injectable({
  providedIn: 'root'
})
export class ReviewService {
  constructor(
    private http: HttpClient,
    private errorService: ErrorService
  ) { }

  getUserTasks(buildingId: string): Observable<any> {
    const url = environment.apiBaseUrl + endpoints.getUserTasks.replace(':buildingId', buildingId);
      return this.http.get<any>(url).pipe(
        catchError(this.errorService.handleError)
      );
  }

  requestReview(data: any): Observable<any> {
    const url = environment.apiBaseUrl + endpoints.requestReview;
    return this.http.post(url, data).pipe(
      catchError(this.errorService.handleSavingError)
    );
  }

  cancelReviewRequest(data: IReview): Observable<any> {
    const url = environment.apiBaseUrl + endpoints.cancelReviewRequest;
    return this.http.post(url, data).pipe(
      catchError(this.errorService.handleSavingError)
    );
  }

  reviewCompleted(data: IReview, formName?: string): Observable<any> {
    const url = environment.apiBaseUrl + endpoints.reviewApprove + `?form_name=${formName}`;
    return this.http.post(url, data).pipe(
      catchError(this.errorService.handleSavingError)
    );
  }
}